import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../../../reducers';
import RangeSlider from '../../../../Form/RangeSlider';
import Tooltip from './Tooltip';
import { Wrapper, MediaWrapper, MediaWrapperColumn, MediaInner, Image, RangeSliderWrapper, Label } from './styles';
import { FilledPositionConfig, PreviewMode } from '../../../Spread/Background';
import { setSpreadBackground } from '../../../../../containers/Editor/actions';
import { BackgroundImageOrMovieData } from '../../../../../containers/Editor/reducer';

interface MediaPreviewProps {
	url: string;
	spread: number[];
	bgMediaData: BackgroundImageOrMovieData;
	isGeneralBgData: boolean;
	position: FilledPositionConfig;
	onPositionChange: (value: FilledPositionConfig) => void;
	dispatch: Dispatch<StoreState>;
}

enum PositionParam {
	TOP = 'top',
	LEFT = 'left',
	SCALE = 'scale',
}

const MediaPreview = ({
	url,
	spread,
	bgMediaData,
	isGeneralBgData,
	position,
	onPositionChange,
	dispatch,
}: MediaPreviewProps) => {
	const [activeMode, setActiveMode] = React.useState(PreviewMode.DESKTOP);

	const handleChange = (param: PositionParam, value: number) => {
		onPositionChange({
			...position,
			[activeMode]: {
				...position[activeMode],
				[param]: value,
			},
		});
	};

	const handleFinalChange = (param: PositionParam, value: number) => {
		dispatch(setSpreadBackground(spread, {
			...bgMediaData,
			position: {
				...bgMediaData.position,
				[activeMode]: {
					...(bgMediaData.position || {})[activeMode],
					[param]: value,
				},
			},
		}, isGeneralBgData));
	};

	return (
		<Wrapper>
			<MediaWrapper>
				<MediaWrapperColumn>
					<Label
						value="messages.desktop"
						isActive={activeMode === PreviewMode.DESKTOP}
					/>
					<MediaInner
						isActive={activeMode === PreviewMode.DESKTOP}
						onClick={() => setActiveMode(PreviewMode.DESKTOP)}
					>
						<Image
							url={url}
							top={position[PreviewMode.DESKTOP].top}
							left={position[PreviewMode.DESKTOP].left}
							scale={position[PreviewMode.DESKTOP].scale}
						/>
					</MediaInner>
				</MediaWrapperColumn>
				<MediaWrapperColumn>
					<Label
						value="messages.phone"
						isActive={activeMode === PreviewMode.PHONE}
					/>
					<MediaInner
						isActive={activeMode === PreviewMode.PHONE}
						onClick={() => setActiveMode(PreviewMode.PHONE)}
						isPhone={true}
					>
						<Image
							url={url}
							top={position[PreviewMode.PHONE].top}
							left={position[PreviewMode.PHONE].left}
							scale={position[PreviewMode.PHONE].scale}
						/>
					</MediaInner>
				</MediaWrapperColumn>
			</MediaWrapper>
			<RangeSliderWrapper hasTooltip={true}>
				<RangeSlider
					labels={{
						left: 'messages.top',
						right: 'messages.bottom',
					}}
					step={1}
					min={0}
					max={100}
					value={position[activeMode].top as number}
					onChange={(value) => handleChange(PositionParam.TOP, value)}
					onFinalChange={(value) => handleFinalChange(PositionParam.TOP, value)}
				/>
				<Tooltip message="messages.bg_cover_top_tooltip" />
			</RangeSliderWrapper>
			<RangeSliderWrapper hasTooltip={true}>
				<RangeSlider
					labels={{
						left: 'messages.left',
						right: 'messages.right',
					}}
					step={1}
					min={0}
					max={100}
					value={position[activeMode].left as number}
					onChange={(value) => handleChange(PositionParam.LEFT, value)}
					onFinalChange={(value) => handleFinalChange(PositionParam.LEFT, value)}
				/>
				<Tooltip message="messages.bg_cover_left_tooltip" />
			</RangeSliderWrapper>
			<RangeSliderWrapper>
				<RangeSlider
					labels={{
						left: 'messages.scale',
					}}
					step={0.01}
					min={1}
					max={2}
					value={position[activeMode].scale as number}
					onChange={(value) => handleChange(PositionParam.SCALE, value)}
					onFinalChange={(value) => handleFinalChange(PositionParam.SCALE, value)}
				/>
			</RangeSliderWrapper>
		</Wrapper>
	);
};

export default MediaPreview;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SpreadBackgroundPanel/MediaPreview/index.tsx